import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { PostHogProvider } from 'posthog-js/react';

import './i18n';

import './index.css';
import App from './app';
import { initPostHog, posthog } from './lib/analytics/posthog';

// Init before the first render so the very first pageview RootLayout sends
// already has a live client.
initPostHog();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </StrictMode>
);
